module.exports = __webpack_public_path__ + "0dee49e714968374e1f0b61d1f558775.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/march-marathon-medal-s.png
// module id = 1305
// module chunks = 0